import React, {
  createContext,
  useReducer,
  useContext,
  useCallback,
} from "react";
import { append, uniq } from "ramda";

const actionTypes = {
  update_updated_thumbnails: "update_updated_thumbnails",
};

export const CreatorContext = createContext(null);
export const CreatorDispatchContext = createContext(null);

const initialCreatorContext = {
  // Track updated thumbnails for cache busting
  updatedThumbnails: [],
};

const creatorReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.update_updated_thumbnails: {
      return {
        ...state,
        updatedThumbnails: action.updatedThumbnails,
      };
    }
    default: {
      throw new Error(
        "Unhandled type in CreatorContext reducer: ",
        action.type,
      );
    }
  }
};

export const CreatorProvider = ({ children }) => {
  const [state, dispatch] = useReducer(creatorReducer, initialCreatorContext);

  const addUpdatedThumbnail = useCallback(
    id => {
      dispatch({
        type: actionTypes.update_updated_thumbnails,
        updatedThumbnails: uniq(append(id, state.updatedThumbnails)),
      });
    },
    [state.updatedThumbnails],
  );

  return (
    <CreatorContext.Provider value={state}>
      <CreatorDispatchContext.Provider value={{ addUpdatedThumbnail }}>
        {children}
      </CreatorDispatchContext.Provider>
    </CreatorContext.Provider>
  );
};

export const useCreatorContext = () => {
  return useContext(CreatorContext);
};

export const useCreatorDispatch = () => {
  return useContext(CreatorDispatchContext);
};
